import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Signup from "../pages/Signup";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import Startpage from "../pages/Startpage";
import Questions from "../pages/Questions";
import ThankYou from "../pages/ThankYou";
import PageNotFound from "../pages/PageNotFound";
import AdminLogin from "../pages/AdminLogin";
import Assessments from "../pages/Assessments";
import AdminLayout from "../pages/AdminLayout";
import { Book, Bookmark } from "react-bootstrap-icons";
import { useUser } from "../components/UserContext";
import EditAssessment from "../pages/EditAssessment";
import Attempts from "../pages/Attempts";
import AdminSignup from '../pages/AdminSignup'
import ResetPassword from '../pages/ResetPassword';
import EmailVerify from "../pages/EmailVerify";

export const routes = [
  {
    name: "Assessments",
    path: "assessments",
    ele: <Assessments />,
    icon: <Book />,
    isSuperUser: true,
    isMenu: true,
  },
  {
    name: "Attempts",
    path: "attempts",
    ele: <Attempts />,
    icon: <Bookmark />,
    isSuperUser: true,
    isMenu: true,
  },
  {
    name: "Edit Assessments",
    path: "assessment/:id",
    ele: <EditAssessment />,
    isSuperUser: true,
    isMenu: false,
  },
];

const RoutesWrapper = () => {
  const { user } = useUser();

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/assessment/login" replace />} />
      <Route
        path="/assessment"
        element={<Navigate to="/assessment/login" replace />}
      />
      <Route path="/assessment/:hash" element={<Signup />} />
      <Route
        path="/admin/login"
        element={
          <PublicRoutes>
            <AdminLogin />
          </PublicRoutes>
        }
      />
      <Route
        path="/admin/signup"
        element={
          <PublicRoutes>
            <AdminSignup />
          </PublicRoutes>
        }
      />
      <Route
        path="/emailVerify"
        element={
          <PublicRoutes>
            <EmailVerify />
          </PublicRoutes>
        }
      />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="assessments" />} />
        {routes?.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<PrivateRoutes isAdmin={true}>{route.ele}</PrivateRoutes>}
          />
        ))}
      </Route>
      <Route
        path="/startpage"
        element={
          <PrivateRoutes isAdmin={false}>
            <Startpage />
          </PrivateRoutes>
        }
      />
      <Route
        path="/questions"
        element={
          <PrivateRoutes isAdmin={false}>
            <Questions />
          </PrivateRoutes>
        }
      />
      <Route
        path="/thankyou"
        element={
          <PrivateRoutes isAdmin={false}>
            <ThankYou />
          </PrivateRoutes>
        }
      />
      <Route
        path="/reset-password/:vhash"
        element={
          <PublicRoutes>
            <ResetPassword />
          </PublicRoutes>
        }
      />
      <Route path="/unauthorized" element={<PageNotFound />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default RoutesWrapper;
